<template>
    <div class='canvas-container'>
        <DynamicContent :content='content' v-if='content.page != null'/>
    </div>
</template>

<script>
import DynamicContent from '@/global/components/dynamic_pages/DynamicContent.vue';
import {loadDynamicContent}  from "@/page_builder/builder/builder_tools/functions/pagebuilder_functions.js";
          import {setMetaTags} from "@/global/modules/functions.js";
          
export default {
    components: {DynamicContent},
    data(){
        return{
            content: {}
        }
    },
    methods:{
        async getDynamicContent(){
            this.content = await loadDynamicContent(this.$route.path);
             const canonical_url = window.location.origin + this.$route.path;
            setMetaTags(this.content.page.config.title, this.content.page.config.description, this.content.page.config.meta_tags, canonical_url);
            // import(`/public/dynamic_pages/content/dynamicexample1.json`).then((content) => {
            //     this.content = content;
            // });
        }
    },
    beforeMount(){
        // if(process.env.NODE_ENV !== 'development'){ //Prod import from cached files
        //     import(`/public/dynamic_pages/routes.json`).then((routes) => {
        //         let dynamic_routes = Array.from(routes); //Turn from ES6 module to array
        //         let filename = dynamic_routes.filter(x=>x.url == this.$route.path)[0].id;
                
        //         import(`/public/dynamic_pages/content/${filename}.json`).then((content) => {
        //             this.content = content;
        //         });
        //     });
        // }
        // else{ //Dev grab from db
            // this.getDynamicContent();
        // }
    },
    created(){
        this.getDynamicContent();
    }
}
</script>